<div class="sidenav-hold" #sidenav>
  @if (hasIconTypeMenuItem) {
    <div class="icon-menu mb-16">
      <!-- Icon menu separator -->
      <div class="mb-16 nav-item-sep">
        <mat-divider [ngStyle]="{margin: '0 -24px'}"></mat-divider>
        <span class="text-muted icon-menu-title">{{iconTypeMenuTitle}}</span>
      </div>
      <!-- Icon menu items -->
      @for (item of menuItems; track item) {
        <div class="icon-menu-item">
          @if (!item.disabled && item.type === 'icon') {
            <button mat-raised-button [matTooltip]="item.tooltip"
              routerLink="/{{item.state}}" routerLinkActive="mat-bg-primary">
              @if (item.icon) {
                <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
              }
              @if (item.svgIcon) {
                <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
              }
            </button>
          }
        </div>
      }
    </div>
  }

  <ng-container *ngTemplateOutlet="menuTemplate; context: {menuItems: menuItems}"></ng-container>

</div>

<ng-template #menuTemplate let-menuItems="menuItems">
  <ul appDropdown class="sidenav">
    @for (item of menuItems; track item) {
      <li appDropdownLink>
        <!-- separator -->
        @if (item.type === 'separator') {
          <div class="nav-item-sep">
            <mat-divider></mat-divider>
            <span class="text-muted">{{item.name }}</span>
          </div>
        }
        <!-- Item -->
        @if (!item.disabled && item.type !== 'separator' && item.type !== 'icon') {
          <div class="lvl1">
            @if (item.type !== 'extLink' && item.type !== 'dropDown') {
              <a routerLink="/{{item.state}}" appDropdownToggle matRipple
                routerLinkActive="open" (click)="onMenuItemClick($event)">
                @if (item.icon) {
                  <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
                }
                @if (item.svgIcon) {
                  <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
                }
                <span class="item-name lvl1">{{item.name }}</span>
                <span class="splitter"></span>
                @for (badge of item.badges; track badge) {
                  <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
                  >{{ badge.value }}</span>
                }
              </a>
            }
            @if (item.type === 'extLink') {
              <a [href]="item.state" appDropdownToggle matRipple target="_blank">
                @if (item.icon) {
                  <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
                }
                <span class="item-name lvl1">{{item.name }}</span>
                <span class="splitter"></span>
                @for (badge of item.badges; track badge) {
                  <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
                  >{{ badge.value }}</span>
                }
              </a>
            }
            <!-- DropDown -->
            @if (item.type === 'dropDown') {
              <a appDropdownToggle matRipple>
                @if (item.icon) {
                  <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
                }
                @if (item.svgIcon) {
                  <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
                }
                <span class="item-name lvl1">{{item.name }}</span>
                <span class="splitter"></span>
                @for (badge of item.badges; track badge) {
                  <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
                  >{{ badge.value }}</span>
                }
                <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
              </a>
            }
            <mat-divider></mat-divider>
            @if (item.type === 'dropDown') {
              <div>
                <ng-container *ngTemplateOutlet="menuTemplate; context: {menuItems: item.sub}"></ng-container>
              </div>
            }
          </div>
        }
      </li>
    }
  </ul>
</ng-template>
